import React from 'react';
import ProductHydroTable from './ProductHydroTable';

const ProductHydro = props => <ProductHydroTable {...props} />;

export default ProductHydro;
